module.exports = __webpack_public_path__ + "img/icon_member.0cb9c312.png";